<template>
  <div
    ref="wrapper"
    :class="['min-w-full min-h-full ', hasError ? 'relative' : '']"
    :style="{
      ...ratioStyle,
    }"
  >
    <img
      :src="src"
      :alt="alt"
      v-bind="$attrs"
      ref="image"
      @load="handleSucces"
      @error="handleError"
      :class="[
        'w-full h-full transition-opacity duration-700 object-cover',
        isLoaded ? 'opacity-100' : 'opacity-0',
        this.$vnode.data.staticClass,
        this.$vnode.data.class,
        'hello'
      ]"
      :loading="lazy === true ? 'lazy' : lazy === false ? 'eager' : 'auto'"
      :style="
        keepRatio && {
          ...ratioStyle,
        }
      "
    />
    <VueSkeletonLoader
      v-if="!isLoaded && !hasError"
      class="w-full h-full"
      type="rect"
      width="100%"
      height="100%"
      animation="wave"
    />
    <div
      v-if="hasError && !isLoaded"
      class="bg-gray-200 w-full h-full flex items-center justify-center absolute top-0 left-0 bottom-0 right-0"
    >
      <img v-if="!$slots.default" :src="imageIcon" class="w-10 opacity-20" />
      <slot v-else />
    </div>
  </div>
</template>

<script>
import VueSkeletonLoader from "skeleton-loader-vue";
import { mapGetters } from "vuex";
import imageIcon from "../assets/images/icons/image.svg";

export default {
  data: () => ({
    hasError: false,
    isLoaded: false,
    imageIcon,
    kioskPreview: true,
    dimensions: {
      width: 0,
      height: 0,
    },
    observer: undefined,
  }),
  props: {
    item: {
      default: false,
    },
    src: String,
    alt: String,
    lazy: {
      type: [Boolean, String],
      default: true,
    },
    keepRatio: Boolean,
  },
  components: {
    VueSkeletonLoader,
  },
  methods: {
    handleSucces() {
      this.isLoaded = true;
    },
    handleError() {
      return (this.hasError = true);
    },
  },
  computed: {
    ...mapGetters(["menu"]),
    ratioStyle() {
      /**
       * If keep ratio is enabled, return needed styles
       * This can be spread in component's style props
       * 
       * For frydate menu, it was required to fix the menu heights.
       * So instead of providing the min height, we are just providing the height only.
       */
      if (this.item && this.item.is_banner_product) {
        return this.keepRatio
                ? { "max-height": (this.dimensions.width - 4 * 16)/3 + "px" }
                : {};
      }
      else if (this.menu.layout == "frydate") {
        return this.keepRatio
                ? { "height": this.dimensions.width + "px" }
                : {};
        // Temporary solution for the menus(layout : imageFix) where the product image height is too high
      } else if (this.menu.layout == "imageFix") {
        return this.keepRatio
                ? { "max-height": this.dimensions.width + "px" }
                : {};
      }
      else {
        return this.keepRatio
                ? { "min-height": this.dimensions.width + "px" }
                : {};
      }
    },
  },
  mounted() {
    const self = this;

    // get image node
    const img = this.$refs.image;

    // create obesever for the image size when prop is provided on component
    if (this.keepRatio)
      this.observer = new ResizeObserver(() => {
        /**
         * This callback is excecuted everytime something changes to the size
         */

        // save width and height in const
        const width = img.offsetWidth;
        const height = img.offsetHeight;

        // create object with new dimensions for reusability
        const newDimensions = {
          width,
          height,
        };

        // save new dimensions to data prop
        self.dimensions = newDimensions;

        // emit event for further implementation in the future
        self.$emit("resize", newDimensions);
      }).observe(img);
  },
  beforeDestroy() {
    /**
     * disconnect observer if one is added by ratio feature for increased performance
     */
    if (this.keepRatio && this.observer) this.observer.disconnect();
  },
};
</script>

<style lang="scss"></style>
